import clsx from 'clsx';

type IconProps = {
  name: string;
  className?: string;
};

const Icon = (props: IconProps) => {
  const { name, className } = props;
  return (
    <span className={clsx('material-symbols-outlined', className)}>
      {name}
    </span>
  );
};

export default Icon;
